import React, { useMemo } from 'react'
import { Divider, Row, Typography } from 'antd'

import { GridFormItem } from '../../../core/components/sections'
import { formatDateFromNow } from '../../../core/utils'

import {
  EXCLUSION_STATUS,
  USER_ASSIGNMENT_ACTION_TYPE,
} from '../../../common/constants'

import { BRAND_CURATION_TASK_STATUS } from '../../constants'
import { brandCurationTaskPropType } from '../../prop-types'

import BrandCurationTaskUserAssignment from './brand-curation-task-user-assignment'

const BrandCurationTaskDetails = ({ brandCurationTask }) => {
  const isReopenedManually = useMemo(
    () =>
      brandCurationTask?.taskStatus ===
        BRAND_CURATION_TASK_STATUS.REOPENED.value &&
      brandCurationTask?.isReopenedManually,
    [brandCurationTask?.isReopenedManually, brandCurationTask?.taskStatus],
  )

  return (
    <>
      <Row gutter={16}>
        <GridFormItem span={4} label="Assigned Curator">
          <BrandCurationTaskUserAssignment
            brandCurationTaskId={brandCurationTask?.id}
            userActionType={USER_ASSIGNMENT_ACTION_TYPE.CURATION}
            assignedUser={brandCurationTask?.assignedCurator}
            otherAssignedUsers={[brandCurationTask?.assignedQc?.id]}
          />
        </GridFormItem>

        <GridFormItem span={4} label="Assigned Qa">
          <BrandCurationTaskUserAssignment
            brandCurationTaskId={brandCurationTask?.id}
            userActionType={USER_ASSIGNMENT_ACTION_TYPE.QA}
            assignedUser={brandCurationTask?.assignedQa}
            otherAssignedUsers={[brandCurationTask?.assignedQc?.id]}
          />
        </GridFormItem>

        <GridFormItem span={4} label="Assigned Qc">
          <BrandCurationTaskUserAssignment
            brandCurationTaskId={brandCurationTask?.id}
            userActionType={USER_ASSIGNMENT_ACTION_TYPE.QC}
            assignedUser={brandCurationTask?.assignedQc}
            otherAssignedUsers={[
              brandCurationTask?.assignedCurator?.id,
              brandCurationTask?.assignedQa?.id,
            ]}
          />
        </GridFormItem>

        <GridFormItem span={4} label="Status">
          <Typography.Text strong>
            {`${
              BRAND_CURATION_TASK_STATUS[brandCurationTask.taskStatus]?.label
            }${isReopenedManually ? ' (Manually)' : ''}`}
          </Typography.Text>
        </GridFormItem>

        <GridFormItem span={4} label="AutoEat Status">
          {EXCLUSION_STATUS[brandCurationTask.brand?.status]?.label}
        </GridFormItem>

        <GridFormItem span={4} label="Update">
          {brandCurationTask?.brand?.updatedAt &&
            formatDateFromNow(brandCurationTask?.brand?.updatedAt)}
        </GridFormItem>
      </Row>
      <Divider />
    </>
  )
}

BrandCurationTaskDetails.propTypes = {
  brandCurationTask: brandCurationTaskPropType.isRequired,
}

export default BrandCurationTaskDetails
